const g=(l,e)=>{const n=l==null?void 0:l.includes("adsbygoogle"),a=l==null?void 0:l.includes("data-page-url=");if(e&&n&&!a){const o=`<ins class="adsbygoogle"
	data-page-url="${e}"`;return l==null?void 0:l.replace(new RegExp('<ins class="adsbygoogle"',"g"),o)}return l};export{g as htmlFixer};
//# sourceMappingURL=htmlFixer.js.map
